import React from 'react'
import { createRoot } from 'react-dom/client'
import 'react-tooltip/dist/react-tooltip.css'
import 'react-toastify/dist/ReactToastify.css'
import './index.css'

import App from './App'
import Mixpanel from './utils/mixpanel/Mixpanel'

import './polyfill'

new Mixpanel()

if (import.meta.env.REACT_APP_ENABLE_MOCK === 'true') {
  const { worker } = await import('@Mocks/browser')

  console.log(`mock server starting...`)

  await worker.start({
    onUnhandledRequest(req: Request, print: any) {
      if (['/assets', '/img', 'intercom'].some((p) => req.url.includes(p))) {
        return
      }

      print.warning()
    },
  })
}

console.log(
  `${APP_NAME} v${APP_VERSION} built at ${BUILD_DATE} running in ${
    CURRENT_ENV
  } mode...`,
)

createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
